module.exports = __webpack_public_path__ + "img/4_168.44a76e89.png";